import { useMemo } from "react"
import { useOutletContext } from "react-router-dom"
import { useTranslation } from "react-i18next"

import type { Tower } from "types/towers.types"

import { BodyContainer } from "widgets/styled/containers"
import DevicesTable from "widgets/device/DevicesTable"
import TowerDashboard from "widgets/towers/TowerDashboard"
import { useFullDeviceRows } from "helpers/hooks/devices/useFullDeviceRows"
import { getTowerDevicesTabPlotDefs } from "helpers/config/dashboards"
import { isTowerHealthEnabled } from "helpers/utils/towerHealth"
import { nameOrUnnamed } from "helpers/utils/translations"

const TowerDevices = () => {
  const { t } = useTranslation()
  const { tower, towerFetching } = useOutletContext<{
    tower: Tower
    towerFetching: boolean
  }>()
  const { getTowerDevicesRows, installedOnLoading, statusesLoading, isFirstFetch } =
    useFullDeviceRows()

  const towerDevicesRows = useMemo(
    () => getTowerDevicesRows(tower.id),
    [getTowerDevicesRows, tower.id],
  )

  const towerHealthEnabled = isTowerHealthEnabled(tower)

  const tiltConfig = useMemo(
    () => ({
      type: "towerDevicesPlots" as const,
      plotDefs: getTowerDevicesTabPlotDefs(),
    }),
    [],
  )

  return (
    <BodyContainer disableGutters maxWidth="xl">
      <DevicesTable
        devices={towerDevicesRows}
        statusesLoading={statusesLoading}
        installedOnLoading={installedOnLoading}
        isWaiting={towerFetching || isFirstFetch}
        fileNameEntity={`tower_${nameOrUnnamed(tower.name, t)}`}
        sx={{ mt: "1rem" }}
      />
      {towerHealthEnabled && (
        <TowerDashboard tower={tower} towerFetching={towerFetching} config={tiltConfig} />
      )}
    </BodyContainer>
  )
}

export default TowerDevices
